import HowToParticipate from "./how-to-participate";

const participatePageRoutes = [
    { path: "como-participar", element: <HowToParticipate /> },
    { path: "how-to-participate", element: <HowToParticipate /> },
];

export default participatePageRoutes;
